var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteRequest2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4996_36291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43044 15.375H1.875C1.18466 15.375 0.625 14.8153 0.625 14.125V1.875C0.625 1.18466 1.18466 0.625 1.875 0.625H7.875C8.22016 0.625 8.53266 0.764906 8.75887 0.991125L10.0089 2.24113C10.2351 2.46731 10.375 2.77981 10.375 3.125V6.56809",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2375 7.23721C13.7256 6.74905 14.5171 6.74905 15.0052 7.23721C15.4934 7.72537 15.4934 8.51684 15.0052 9.00499L9.83863 14.1716C9.74803 14.2622 9.64406 14.3383 9.53031 14.3973L7.77994 15.3053C7.54456 15.4274 7.24778 15.3897 7.05025 15.1922C6.85275 14.9947 6.81506 14.6979 6.93716 14.4625L7.84513 12.7121C7.90413 12.5984 7.98025 12.4944 8.07084 12.4038L13.2375 7.23721Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.375H7.875",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 7.875H7.875",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10.375H5.375",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4996_36291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRequest2);
export default __webpack_public_path__ + "static/media/quote-request 2.41abfbe1e64491f10dc988904e1ef038.svg";
export { ForwardRef as ReactComponent };